import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { EntityService } from '@services/core/entity.service';
import { map } from 'rxjs/operators';

export const groupResolver: ResolveFn<any> = () => {
  const entityService = inject(EntityService)

  return entityService.getGroupsEntities().pipe(
    map(groups => ({ groups, groupsTemp: groups }))
  )
}
